export const borderRadius: any = () => "8px";

export const noMargin: any = (page: any) => {
  let noMarginOnNewPaymentDetail;
  if (page === "ALL") {
    noMarginOnNewPaymentDetail = false;
  } if (page === "SAVED") {
    noMarginOnNewPaymentDetail = false;
  }
  return noMarginOnNewPaymentDetail;
};
